module.exports = __webpack_public_path__ + "static/engine-modular-framework-for-web-5800050e17126cff12e3006a90e27894.jpg";